<template>
  <section id="stripes" class="stripes none">
    <section class="str strp0"></section>
    <section class="str strp1"></section>
    <section class="str strp2"></section>
    <section class="str strp3"></section>
    <section class="str strp4"></section>
    <section class="str strp5"></section>
  </section>
</template>

<script>
export default {
  name: 'stripes',
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Template_Stripes.vue